/** @jsx jsx */
import { jsx } from '@emotion/core'
import { HFlow, Text, VFlow } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import { AgendamentoCidadaoHeader } from 'view/agenda/cidadao/list/components/AgendamentoCidadaoHeader'
import { AgendamentoCidadaoLotacaoAgendada } from 'view/agenda/cidadao/list/components/AgendamentoCidadaoLotacaoAgendada'
import { AgendamentoCompartilhadoCidadaoProfissionaisAgendados } from 'view/agenda/cidadao/list/components/AgendamentoCompartilhadoCidadaoProfissionaisAgendados'
import { AgendamentoCidadaoModel } from 'view/agenda/cidadao/model-cidadao'
import { AgendamentoFooter } from 'view/agenda/components/AgendamentoFooter'
import { SituacaoAgendamentoBar } from 'view/agenda/components/SituacaoAgendamentoBar'

interface AgendamentoCidadaoSectionProps {
  agendamento: AgendamentoCidadaoModel
  isAgendaOnlineAtiva: boolean
}

export function AgendamentoCidadaoSection(props: Readonly<AgendamentoCidadaoSectionProps>) {
  const { agendamento, isAgendaOnlineAtiva } = props

  return (
    <HFlow hSpacing={0}>
      <SituacaoAgendamentoBar situacao={agendamento.situacao} />
      <VFlow vSpacing={0.5}>
        <AgendamentoCidadaoHeader agendamento={agendamento} />
        {!agendamento.agendamentoPrincipal?.lotacaoAgendada ? (
          <AgendamentoCidadaoLotacaoAgendada lotacaoAgendada={agendamento.lotacaoAgendada} />
        ) : (
          <AgendamentoCompartilhadoCidadaoProfissionaisAgendados
            agendamentoPrincipal={agendamento.agendamentoPrincipal}
            lotacaoParticipante={agendamento.lotacaoParticipante}
            nomeUnidadeSaude={agendamento.lotacaoAgendada?.unidadeSaude?.nome}
          />
        )}
        {agendamento.observacao && (
          <HLabel title='Observações:'>
            <Text fontStyle='italic'>{agendamento.observacao}</Text>
          </HLabel>
        )}
        <AgendamentoFooter
          color='secondary'
          responsavelCriador={agendamento.responsavelCriador}
          dataCriacao={agendamento.dataCriacao}
          origem={agendamento.origem}
          situacaoSincronizacao={agendamento.situacaoSincronizacao}
          isAgendaOnlineAtiva={isAgendaOnlineAtiva}
          justificativaCancelamento={agendamento.justificativaCancelamento}
        />
      </VFlow>
    </HFlow>
  )
}
